import { WidgetType } from './widget-type';

export interface FindWidgetParams {
  owner_id: string;
  owner_type: string;
  widget_type: WidgetType;
}
